<script setup>


// import AuthLinks from './AuthLinks.vue';

import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const props = defineProps({
  menuData: {
    type: Object,
    default: null
  }
})

const route = useRoute()
const router = useRouter()

const hoveredItems = ref({})
const isMobileMenuOpen = ref(false)
const expandedLevel2 = ref([]) // 存储展开的二级菜单ID
const expandedLevel3 = ref([]) // 存储展开的三级菜单ID

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
  if (!isMobileMenuOpen.value) {
    expandedLevel2.value = []
    expandedLevel3.value = []
  }
}

const toggleLevel2 = (name) => {
  if (expandedLevel2.value.includes(name)) {
    expandedLevel2.value = expandedLevel2.value.filter((n) => n !== name)
    expandedLevel3.value = expandedLevel3.value.filter(
      (n) => !n.startsWith(`${name}-`)
    )
  } else {
    expandedLevel2.value = [...expandedLevel2.value, name]
  }
}

const toggleLevel3 = (parentName, name) => {
  const fullName = `${parentName}-${name}`
  if (expandedLevel3.value.includes(fullName)) {
    expandedLevel3.value = expandedLevel3.value.filter((n) => n !== fullName)
  } else {
    expandedLevel3.value = [...expandedLevel3.value, fullName]
  }
}

const isLevel2Expanded = (name) => expandedLevel2.value.includes(name)

const isLevel3Expanded = (parentName, name) =>
  expandedLevel3.value.includes(`${parentName}-${name}`)

const handleMouseEnter = (name) => {
  hoveredItems.value[name] = true
}

const handleMouseLeave = (name) => {
  hoveredItems.value[name] = false
}

const isHovered = (name) => !!hoveredItems.value[name]

const normalizePath = (path) => '/' + path.replace(/^\/+/, '')

const handleLevel1Click = (item, event) => {
   console.log("handleLevel1Click ddddddddddddddddddddddd")
  // if (item.children?.length) {
    // event.preventDefault()
    // toggleLevel2(item.metadata.name)
  // } else {
    router.push(normalizePath(item.status?.href || '/'))
    // isMobileMenuOpen.value = false
    // resetExpandedStates()
  // }
}

const handleLevel2Click = (parentName, item, event) => {
  console.log("handleLevel2Click ddddddddddddddddddddddd")
  // if (item.children?.length) {
  //   event.preventDefault()
  //   toggleLevel3(parentName, item.metadata.name)
  // } else {
  //   router.push(normalizePath(item.status?.href || '/'))
  //   isMobileMenuOpen.value = false
  //   resetExpandedStates()
  // }
  router.push(normalizePath(item.status?.href || '/'))
}

const handleLevel3Click = (item, event) => {
  router.push(normalizePath(item.status?.href || '/'))
  isMobileMenuOpen.value = false
  resetExpandedStates()
}

const resetExpandedStates = () => {
  expandedLevel2.value = []
  expandedLevel3.value = []
}

const menuItems = computed(() => {
  if (!props.menuData || !Array.isArray(props.menuData.menuItems)) return []
  return props.menuData.menuItems
    .filter(item => (item.spec?.href || '') !== '/login' && (item.spec?.href || '') !== '/register')
    .sort((a, b) => (a.spec?.priority || 0) - (b.spec?.priority || 0))
})

const handleOutsideClick = (e) => {
  const menu = document.querySelector('.mobile-menu')
  const burger = document.querySelector('.hamburger')
  if (
    isMobileMenuOpen.value &&
    menu && !menu.contains(e.target) &&
    burger && !burger.contains(e.target)
  ) {
    isMobileMenuOpen.value = false
    resetExpandedStates()
  }
}

onMounted(() => {
  document.addEventListener('click', handleOutsideClick)
})

onUnmounted(() => {
  document.removeEventListener('click', handleOutsideClick)
})
</script>

<template>
  <div class="nav-container">
    <!-- <router-link to="/" class="logo">
      <img src="@/assets/logo.png" alt="Logo" />
    </router-link> -->

    <!-- PC端菜单 -->
    <nav class="nav-menu desktop-only">
      <ul class="nav-list">
        <li v-for="item in menuItems" :key="item.metadata.name" class="nav-item"
          @mouseenter="handleMouseEnter(item.metadata.name)" @mouseleave="handleMouseLeave(item.metadata.name)">
          <a :href="normalizePath(item.status?.href || '/')" class="nav-link"
            :class="{ active: route.name === item.metadata.name }" @click="handleLevel1Click(item, $event)">
            {{ item.displayName }}
            <span v-if="item.children?.length" class="submenu-indicator"
              :class="{ rotated: isLevel2Expanded(item.metadata.name) }">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
          </a>

          <!-- 二级菜单 -->
          <div v-if="item.children?.length" class="dropdown" :class="{ show: isHovered(item.metadata.name) }">
            <div v-for="child in item.children" :key="child.metadata.name" class="dropdown-column">
              <!-- 让二级菜单标题可点击 -->
              <a :href="normalizePath(child.status?.href || '/')" class="column-title"
                :class="{ active: route.name === child.metadata.name }"
                @click="handleLevel2Click(item.metadata.name, child, $event)">
                {{ child.displayName }}
              </a>

              <!-- 如果有三级菜单，才渲染 -->
              <ul v-if="child.children?.length"
                :class="['submenu-list', { 'two-columns': child.children.length > 15 }]">
                <li v-for="grandchild in child.children" :key="grandchild.metadata.name" class="submenu-item">
                  <a :href="normalizePath(grandchild.status?.href || '/')" class="submenu-link"
                    :class="{ active: route.name === grandchild.metadata.name }"
                    @click="handleLevel3Click(grandchild, $event)">
                    {{ grandchild.displayName }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

        </li>
      </ul>
    </nav>



    <!-- 引入 AuthLink 组件 -->
    <!-- <AuthLinks /> -->

    <!-- 移动端汉堡按钮 -->
    <div class="hamburger" @click="toggleMobileMenu" :class="{ active: isMobileMenuOpen }">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </div>
  </div>

  <!-- 移动端菜单浮层 -->
  <nav class="mobile-menu" :class="{ open: isMobileMenuOpen }">
    <ul class="level-1-list">
      <!-- 一级菜单 -->
      <li v-for="item in menuItems" :key="item.metadata.name" class="level-1-item">
        <a :href="normalizePath(item.status?.href || '/')" class="level-1-link"
          :class="{ active: route.name === item.metadata.name }" @click="handleLevel1Click(item, $event)">
          {{ item.displayName }}
          <span v-if="item.children?.length" class="submenu-indicator"
            :class="{ rotated: isLevel2Expanded(item.metadata.name) }">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </a>

        <!-- 二级菜单 - 在一级菜单下方展示 -->
        <ul v-if="item.children?.length" class="level-2-list" :class="{ show: isLevel2Expanded(item.metadata.name) }">
          <li v-for="child in item.children" :key="child.metadata.name" class="level-2-item">
            <a :href="normalizePath(child.status?.href || '/')" class="level-2-link"
              :class="{ active: route.name === child.metadata.name }"
              @click="handleLevel2Click(item.metadata.name, child, $event)">
              {{ child.displayName }}
              <span v-if="child.children?.length" class="submenu-indicator"
                :class="{ rotated: isLevel3Expanded(item.metadata.name, child.metadata.name) }">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </span>
            </a>

            <!-- 三级菜单 - 在二级菜单下方展示 -->
            <ul v-if="child.children?.length" class="level-3-list"
              :class="{ show: isLevel3Expanded(item.metadata.name, child.metadata.name) }">
              <li v-for="grandchild in child.children" :key="grandchild.metadata.name" class="level-3-item">
                <a :href="normalizePath(grandchild.status?.href || '/')" class="level-3-link"
                  :class="{ active: route.name === grandchild.metadata.name }"
                  @click="handleLevel3Click(grandchild, $event)">
                  {{ grandchild.displayName }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </nav>

</template>
<style scoped>
.nav-item {
  position: relative;
  display: inline-block;
  padding: 0 20px;
  cursor: pointer;
  height: 36px;
  /* line-height: 36px; */
}

.nav-item+.nav-item {
  border-left: 1px solid rgba(255, 255, 255, 0.3);
}

.nav-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
  display: block;
  height: 100%;
  line-height: 50px;
  padding: 0 10px;
  width: auto;
  /* 让背景宽度自适应内容 */
}

.dropdown-column {
  display: inline-block;
  min-width: 150px;
}

.dropdown-column ul {
  padding-left: 10px;
}

.dropdown-column+.dropdown-column {
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  /* 二级菜单项之间加竖线 */
  /* padding-left: 20px; */
}

.nav-container {
  min-width: 790px;
  width: max-content;
  position: absolute;
  top: 127px;
  /* 定位到顶部 */
  left: 50%;
  /* 水平居中 */
  transform: translateX(-50%);
  /* 将元素水平向左移动自身宽度的一半 */
  background-color: #004080;
  color: white;
  font-family: '微软雅黑', sans-serif;
  font-size: 14px;
  display: flex;
  align-items: center;
  height: 40px;
  z-index: 1000;
  justify-content: space-between;
  margin: 0 auto;
  border: 1px solid #003160;
  box-shadow: 0 1px 4px #004080;
  border-radius: 0 0 5px 5px;
}

.logo img {
  height: 30px;
  margin-right: 20px;
}

.nav-menu {
  display: flex;
  flex: 1;
}

.nav-list {
  display: flex;
  list-style: none;
  padding: 0;
  height: 40px;
  align-items: center;
  /* 控制按钮间距 */
  margin: 0;
}

.nav-item {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  flex-shrink: 0;
  /* border-radius: 10%; */
}

/* 用伪元素画分隔线 */
.nav-item::after {
  /* content: "";
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  height: 50%;
  width: 1px;
  background: rgba(255, 255, 255, 0.5); */
}

/* 最后一个不要竖线 */
/* .nav-item:last-child::after {
  display: none;
} */

.nav-link {
  color: white;
  text-decoration: none;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  gap: 8px;
  white-space: nowrap;
}

.nav-link.active,
.nav-item:hover>.nav-link {
  color: white;
  font-weight: 600;
}

.nav-item:hover {
  background-color: #DD0000;
}

.dropdown {
  position: absolute;
  top: 45px;
  left: 0;
  background: #D8EBF9;
  color: #333;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  padding: 20px;
  z-index: 1000;
  display: none;
  gap: 20px;
  border-radius: 4px;
}

.dropdown.show {
  display: flex;
}


.column-title {
  display: block;
  padding: 8px 12px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #004080;
  /* background-color: #f5f5f5;  */
  /* border: 1px solid #ccc; */
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  /* 去掉下划线 */
  cursor: pointer;
  transition: all 0.3s ease;
}

.column-title:hover {
  background-color: #DD0000;
  /* 红色 hover 背景 */
  color: #fff;
  /* 文字白色 */
  border-color: #DD0000;
}


.submenu-item {
  margin: 5px 0;
  list-style: none;
  height: 30px;
  text-align: center;
  line-height: 30px;
}

.submenu-item:hover {
  background: #83ABDC;
  height: 30px;
}

.submenu-link {
  color: #333;
  text-decoration: none;
  font-size: 13px;
}

.submenu-link:hover,
.submenu-link.active {
  text-decoration: none;
}

.submenu-indicator {
  display: none;
  transition: transform 0.3s ease;
}

.submenu-indicator.rotated {
  transform: rotate(180deg);
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  padding: 8px;
  transition: transform 0.3s ease;
}

.hamburger .bar {
  width: 22px;
  height: 2px;
  background-color: white;
  border-radius: 1px;
  transition: all 0.3s ease;
}

.hamburger.active .bar:nth-child(1) {
  transform: translateY(6px) rotate(45deg);
}

.hamburger.active .bar:nth-child(2) {
  opacity: 0;
}

.hamburger.active .bar:nth-child(3) {
  transform: translateY(-6px) rotate(-45deg);
}

/* .desktop-only {
  display: flex;
  justify-content: center;
  height: 40px;
} */

.mobile-menu {
  display: none;
}

.submenu-list.two-columns {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 0 10px;
  /* 行间距 0，列间距 10px */
}

@media (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }

  .hamburger {
    display: flex;
  }

  .mobile-menu {
    display: block;
    position: fixed;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #004080;
    z-index: 1500;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out, padding 0.3s ease-out;
  }

  .mobile-menu.open {
    max-height: 100vh;
    padding-top: 10px;
    overflow-y: auto;
  }

  .level-1-list {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
  }

  .level-1-item {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .level-1-link {
    padding: 14px 16px;
    font-size: 16px;
    width: 100%;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
  }

  .level-1-link.active {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .level-2-list {
    list-style: none;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.1);
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    /* padding-left: 20px; */
  }

  .level-2-list.show {
    max-height: 2000px;
  }

  .level-2-item {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  .level-2-link {
    padding: 12px 16px 12px 32px;
    font-size: 15px;
    width: 100%;
    color: rgba(255, 255, 255, 0.9);
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
  }

  .level-2-link.active {
    background-color: rgba(255, 255, 255, 0.15);
  }

  .level-3-list {
    list-style: none;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.15);
    max-height: 30px;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    padding-left: 40px;
  }

  .level-3-list.show {
    max-height: 2000px;
  }

  .level-3-item {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  .level-3-link {
    padding: 10px 16px 10px 48px;
    font-size: 14px;
    width: 100%;
    color: rgba(255, 255, 255, 0.85);
    display: block;
    text-decoration: none;
  }

  .level-3-link.active {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .level-3-link:hover {
    background-color: #83ABDC;
  }
}
</style>
